<template>
  <div class="trx-page">
    <div class="loading" v-show="loading">
      <i class="fa fa-circle-notch fa-spin"></i>
      <span>Getting Transactions Records...</span>
    </div>

    <div class="empty-state" v-show="transactions.length === 0 && !loading">
      <span>No transaction records yet.</span>
    </div>

    <!-- <div class="local-currency-box d-flex align-center" v-if="currency.currency !== 'USD' && !loading && transactions.length">
      <div class="switch" @click="useLocalCurrency = !useLocalCurrency">
        <div :class="['slider', {'active':useLocalCurrency}]"></div>
      </div>
      <label>USE LOCAL CURRENCY</label>
    </div> -->

    <table v-show="!loading && transactions.length > 0">
      <thead>
        <td>{{ $t('rsvpDetails.transactions.dateTime') }}</td>
        <td>{{ $t('rsvpDetails.transactions.invoiceId') }}</td>
        <td>{{ $t('rsvpDetails.transactions.card') }}</td>
        <td>{{ $t('rsvpDetails.transactions.finalOffer') }}</td>
        <td>{{ $t('rsvpDetails.transactions.chargedAmount') }}</td>
        <td>{{ $t('rsvpDetails.transactions.cancelFee') }}</td>
        <td>{{ $t('rsvpDetails.transactions.bonus') }}</td>
        <td>{{ $t('rsvpDetails.transactions.promoUsed') }}</td>
        <td>{{ $t('rsvpDetails.transactions.status') }}</td>
        <th><i class="stripe-icon fab fa-stripe-s"></i></th>
      </thead>
      <tbody>
        <tr v-for="trx in transactions">
          <td class="date-time">{{ trx.date }}</td>
          <td class="trx">
            <span v-if="trx.trxId !== '0'">{{ trx.trxId }}</span>
            <span v-else>--</span>
          </td>
          <td class="card">{{ trx.cardId }}</td>
          <td class="fare">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.fare) }}</span>
            <span v-else>{{ trx.fare }}</span>
          </td>
          <td class="paid">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.paid) }}</span>
            <span v-else>{{ trx.paid }}</span>
          </td>
          <td class="cancel-fee">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.cancelFee) }}</span>
            <span v-else>{{ trx.cancelFee }}</span>
          </td>
          <td class="bonus">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.bonus) }}</span>
            <span v-else>{{ trx.bonus }}</span>
          </td>
          <td class="promo-used">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.promoUsed) }}</span>
            <span v-else>{{ trx.promoUsed }}</span>
          </td>
          <td class="tbl-status">
            <span v-bind:class="['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', checkReclaimed(trx)]">{{ relabel(trx) }}</span>
          </td>
          <td>
            <span v-if="trx.paymentURL === null">--</span>
            <a v-else :href="trx.paymentURL" target="_blank"><i class="fa fa-link"></i></a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="table-cards" v-show="!loading && transactions.length > 0">
      <div v-for="(trx, i) in transactions" :key="i" class="trans-card">
        <div class="time">
          {{ trx.date }}
        </div>
        <div class="card-header">
          <div class="status">
            <span v-bind:class="['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', checkReclaimed(trx)]">{{ relabel(trx) }}</span>
          </div>
          <div class="amount">
            <span v-if="trx.paymentURL === null">{{ trx.paid }}</span>
            <a v-else :href="trx.paymentURL" target="_blank">{{ trx.paid }} <i class="fa fa-link"></i></a>
          </div>
        </div>
        <div class="title" v-if="trx.trxId !== '0'">
          <div class="label">Invoice ID: </div>
          <div class="value">{{ trx.trxId }}</div>
        </div>
        <div class="title">
          <div class="label">Card:</div>
          <div class="value">{{ trx.cardId }}</div>
        </div>
        <div class="title">
          <div class="label">Charged Amount:</div>
          <div class="value">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.paid) }}</span>
            <span v-else>{{ trx.paid }}</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Cancel Fee:</div>
          <div class="value">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.cancelFee) }}</span>
            <span v-else>{{ trx.cancelFee }}</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Bonus:</div>
          <div class="value">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.bonus) }}</span>
            <span v-else>{{ trx.bonus }}</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Promo Used:</div>
          <div class="value">
            <span v-if="useLocalCurrency">{{ applyCurrency(trx.promoUsed) }}</span>
            <span v-else>{{ trx.promoUsed }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRsvp from '../../modules/api/reservations'

export default {
  name: 'transactions',
  props: ['rsvpId'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    transactions () { return this.$store.state.rsvpDetails.transactionList },
    currency () { return this.$store.state.rsvpDetails.currency },
    useLocalCurrency () { return false },
    // useLocalCurrency: {
    //   get () { return this.$store.state.rsvpDetails.useLocalCurrency },
    //   set (x) { this.$store.commit('rsvpDetails/setLocalCurrency', x) }
    // },
  },
  methods: {
    init () {
      let self = this
      self.loading = true
      self.$store.commit('rsvpDetails/resetTransactionList')
      ApiRsvp.getTransactionByRsvpId(self, self.rsvpId, function (res) {
        self.loading = false
      })
    },
    relabel (trx) {
      if (trx.statusLabel !== 'Credit Conversion') {
        return trx.statusLabel
      }
      return 'Open Credit'
    },
    checkReclaimed (trx) {
      if (trx.transactionType !== 'CONVERT_CREDIT ') {
        return ''
      }

      if (trx.transactionType === 'CONVERT_CREDIT ' && trx.notes === 'RECLAIMED') {
        return 'RECLAIMED'
      }
    },
    applyCurrency (x) {
      x = x.substring(x.indexOf('$') + 1)
      x = parseFloat(x)
      x = x * this.currency.currencyRate
      return `${this.currency.symbol}${x.toFixed(2)}`
    }
  },
  watch: {
    rsvpId: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.trx-page{
  padding: 10px;
}
.loading{
  text-align: center;
  padding: 10px;
  font-size: 18px;

  .fa{
    margin-right: 5px;
    color: #555;
  }
  span{ color: #888; }
}

.empty-state{
  padding: 10px;
  font-size: 18px;
  color: #999;
  text-align: center;
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;
    text-align: center;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px 8px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.card{
          box-shadow: none;
          border: none;
        }
        &.date-time{
          width: 80px;
          line-height: 1.25;
        }
        &.cancel-fee, &.promo-used{ width: 60px; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

.status-label{
  line-height: 1;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 10px!important;
  background: #999;
  display: inline-block;

  &.Purchased, &.Purchase{ background: #4aadf3; }
  &.Completed{ background: #26D97A; }
  &.Promo{ background: #f3904a; }
  &.Edited, &.Refund{ background: #797979; }
  &.No.Show, &.Cancelled, &.Declined{ background: #f54f4f; }
  &.Pending.Refund{
    background: #098769;
    color: #fff;
    line-height: 1.3;
  }
  &.NOT_PROCESSED{
    background: #FFCC00 !important;
    color: #505050 !important;
  }
  &.Credit.Conversion{ background: #29c3c3; }
  &.Credit.Conversion.RECLAIMED{ background: #bbbbbb; }
}

.table-cards {
  display: none;
}

@media only screen and (max-width: 430px) {
  table {
    display: none;
  }

  .table-cards {
    display: block;
  }

  .trans-card {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    padding: 8px;
    padding-bottom: 3px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    .time {
      font-size: 12px;
      color: #777;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-transform: uppercase;

      .amount {
        font-weight: 900;
        font-size: 20px;
        a {
          text-decoration: none;
        }
        i {
          font-size: 15px;
        }
      }
    }

    .title {
      display: flex;
      align-items: center;
    }

    .label {
      font-size: 12px;
      text-transform: uppercase;
      color: #bbb;
      font-weight: 600;
      margin-right: 5px;
    }

    .value {
      margin-right: 10px;
      font-size: 13px;
      font-weight: 900;
    }
  }
}

.switch{
  position: relative;
  display: inline-block;
  height: 23px;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 23px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 30px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 10px;
    margin-left: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}
.local-currency-box{
  margin-bottom: 10px;
  background: #fff792;
  border: 1px solid #cdc23d;
  padding: 5px;
  border-radius: 5px;

  label{
    font-size: 13px;
    color: #565656;
    margin-left: 5px;
    font-family: 'Space Grotesk';
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/Transactions.vue